import { Storage } from 'aws-amplify';

export const PROFILE_IMG_KEY_PREFIX = 'wd-profile-img-';
export const PROFILE_IMG_FOLDER = 'profile';

export const getProfileImageKeys = () =>
  Storage?.list(`${PROFILE_IMG_FOLDER}/${PROFILE_IMG_KEY_PREFIX}`, {
    level: 'private',
  });

export const profileImageExists = async () => {
  const keys = await getProfileImageKeys();
  if (keys?.results?.length > 0) {
    return keys?.results[0]?.key;
  }
  return false;
};
